import { btoa } from "abab"

export const parseFlinksURLString = (
  src: string,
  tag: { email: string; contactId: number; date: string },
  institutionId?: string
) => {
  const base64TagContent = btoa(tag.contactId + "|" + tag.email + "|" + tag.date) ?? ""
  // Maria routes on this prefix and strips it before Stephania decodes the tag.
  const base64Tag = (import.meta.env.VITE_FLINKS_TAG_PREFIX ?? "") + (btoa(base64TagContent + btoa("youwontgetmyemail")) ?? "")
  const isDemo = import.meta.env.VITE_FLINKS_DEMO === "TRUE" ? "demo=true&" : ""
  const backbutton = import.meta.env.VITE_FLINKS_DEMO === "TRUE" ? "backEnable=true" : "backEnable=false"
  const termsUrlEncoded = encodeURIComponent("https://flinks.com/privacy-policy/#htoc-services-privacy-statement");
  if (institutionId && institutionId.length > 0) {
    return `${src}/Credential/${institutionId}?${isDemo}backgroundColor=ffffff&daysOfTransactions=Days365&foregroundColor1=2c2f3e&foregroundColor2=2c2f3e&termsUrl=${termsUrlEncoded}&customerName=iCash&fixedHeightEnable=false&${backbutton}&tag=${base64Tag}&stringify=true&windowContext=parent&consentEnable=false`
  }
  return `${src}?${isDemo}backgroundColor=ffffff&daysOfTransactions=Days365&foregroundColor1=2c2f3e&foregroundColor2=2c2f3e&termsUrl=${termsUrlEncoded}&customerName=iCash&fixedHeightEnable=false&backEnable=true&tag=${base64Tag}&stringify=true&windowContext=parent&consentEnable=false`
}
